import { LoginOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Menu, Popconfirm } from "antd";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import styles from "../../services/styles";
import SL_Button from "../buttons/Button";
import logo from '../../assets/SMYO_logo-31.png'
import generateMenus, { sideMenuItensIconsStyle } from "../../components/menu/Menus"
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { displayMessage } from "../../services/helper";

const { bc1 } = styles

const USER_TYPES = {
    ADMIN: 2,
    DENTIST: 3,
    MONITOR: 1
}

export default function SideMenu() {

    const {
        setLoggedUser, windowHeight, user, selectedLanguage } = useContext(GeneralContext)
        const [currentMenu, setCurrentMenu] = useState(generateMenus())

        useEffect(() => {
            const newMenus = generateMenus()
            setCurrentMenu(newMenus)
        }, [selectedLanguage])


    const [collapsed, setCollapsed] = useState(false);
    const [menu_selected_keys, setMenuSelectedKeys] = useState([])

    const handleOnClickLogout = () => {
        setLoggedUser(false)
    }

    // Lida com clique nos menus
    const handleOnClickItemMenu = e => {
        setMenuSelectedKeys([e.key])
    }

    // Abre e fecha sidebars
    const toggle = () => setCollapsed(!collapsed)

    const menuOptions =
        user?.user_type_formatted?.id == USER_TYPES.ADMIN ? currentMenu.adminSideMenuItens
            : user?.user_type_formatted?.id == USER_TYPES.MONITOR ? currentMenu.monitorSideMenuItens
                : user?.user_type_formatted?.id == USER_TYPES.DENTIST ? currentMenu.dentistSideMenuItens
                    : []
    const listSideMenuItens = [
        ...menuOptions.map(
            item => {
                return {
                    key: item.key,
                    label: (
                        <Link
                            style={{
                                color: menu_selected_keys && menu_selected_keys[0] == item.key ? '#1b3663' : 'white',
                                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                                fontSize: 16,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5
                            }}
                            to={item.key}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {item.icon}

                                <span>{item.title}</span>
                            </div>
                        </Link>
                    )
                }
            }
        ),

        ...currentMenu.topMenuItens.map(
            item => {
                return {
                    key: item.key,
                    label: (
                        <Link
                            style={{
                                color: menu_selected_keys && menu_selected_keys[0] == item.key ? '#1b3663' : 'whitesmoke',
                                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                                fontSize: 16,
                            }}
                            to={item.key}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {item.icon}

                                <span>{item.title}</span>
                            </div>
                        </Link>
                    )
                }
            }
        ),

        {
            key: '/login',
            label: (
                <div style={{ padding: 2 }}>
                    <Popconfirm                        
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('COMFIRMATION_LOGOUT')}
                        onConfirm={handleOnClickLogout}
                        onCancel={()=> setMenuSelectedKeys([])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}>
                        <Link
                            style={{
                                color: 'white',
                                fontSize: 16,
                                fontWeight: 'normal'
                            }}
                            to={'/login'}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <LoginOutlined style={sideMenuItensIconsStyle} />
                                <span>{displayMessage('LOGOUT')}</span>
                            </div>
                        </Link>
                    </Popconfirm>
                </div>
            )
        }
    ]

    return (
        <Sider trigger={null} collapsible collapsed={collapsed} width={300} style={{ display: 'flex', flexDirection: 'column', background: '#c9c9c9' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', borderRight: collapsed ? '' : `2px solid ${bc1}`, marginBottom: collapsed ? 0 : 0 }}>
                <img
                    width={!collapsed ? '50%' : '0px'}
                    style={{ marginLeft: !collapsed ? '12px' : '0px', margin: collapsed ? 0 : 10, padding: collapsed ? 0 : 10 }}
                    src={logo}
                />
                <div style={{ width: !collapsed ? '30%' : '100%' }}>
                    <SL_Button type="primary" onClick={toggle} style={{ background: bc1, borderColor: bc1, justifyContent: "center", margin: 15, marginTop: collapsed ? 15 : 37, borderRadius: 20, width: 54, height: 41 }}>
                        {
                            React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                className: 'trigger',
                                onClick: toggle,
                                style: { justifyContent: "center", fontSize: 24 }
                            })
                        }
                    </SL_Button>
                </div>
            </div>

            <Menu
                mode="inline"
                defaultOpenKeys={['menu']}
                style={{ height: collapsed ? windowHeight - 72 : windowHeight - 95, borderRight: 0, background: bc1, paddingTop: 20 }}
                selectedKeys={menu_selected_keys}
                inlineCollapsed={collapsed}
                onSelect={handleOnClickItemMenu}
                items={listSideMenuItens}
            />
        </Sider>
    )
} 